
  /* "Shop this finish" in the homepage finish viewer rewrites its own href on
     open; force it to the shop page. */
  document.addEventListener('click', function(e){
    var t = e.target;
    while (t && t.nodeType === 1) {
      if (t.id === 'fsShop') { e.preventDefault(); location.href = '/pages/shop'; return; }
      t = t.parentNode;
    }
  }, true);
  